import io from "socket.io-client";

type ClientSocket = ReturnType<typeof io>;

let socket: ClientSocket | null = null;

// Note: returns null during SSR
export const getSocket = (): ClientSocket | null => {
  if (typeof window === "undefined") return null;

  if (!socket) {
    // Attach auth (seller token or admin key) so server can route events safely
    let token = "";
    let adminKey = "";

    try {
      const path = window.location?.pathname || "";
      const isAdmin = path.startsWith("/admin");

      if (isAdmin) {
        const adminToken = window.localStorage.getItem("admin_token_v1") || "";
        if (adminToken) token = adminToken;

        adminKey = window.localStorage.getItem("social_ai_admin_key_v1") || "";
      } else {
        token = window.localStorage.getItem("seller_token_v1") || "";
      }
    } catch {
      // ignore storage access errors
    }

    socket = io(process.env.NEXT_PUBLIC_SOCKET_URL as string, {
      transports: ["websocket"],
      auth: { token, adminKey },
    });
  }

  return socket;
};
